import { store } from "@/store";
import { MODULES, vuexName } from "@/store/utils";
import { TenantEnum } from "@/models/tenant.model";
import { detectTld, TldValues } from "vue-glcommonui";

export function getCurrentTenant(): TenantEnum {
  const tenantStr: string | null | undefined = store.getters[vuexName(MODULES.AUTH.GETTERS.GET_LOGIN_INFO)]?.profile?.tenant;
  if (!tenantStr) return TenantEnum.None;
  const tenantNum = Number(tenantStr);
  return !isNaN(tenantNum) ? (tenantNum as TenantEnum) : TenantEnum[tenantStr as keyof typeof TenantEnum] ?? TenantEnum.None;
}

const SENSITIVE_DATA_RESTRICTED_TENANTS = new Set([TenantEnum.Russia]);

export function isSensitiveDataRestricted(): boolean {
  return SENSITIVE_DATA_RESTRICTED_TENANTS.has(getCurrentTenant());
}

export function isRussiaDomain(): boolean {
  return detectTld(window.location.hostname) === TldValues.Russia;
}
